import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, Think, Button, XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startStreaming,
                'children': '开始流式思考'
            }),
            _$cc(Button, {
                'ev-click': this.reset,
                'children': '重置'
            })
        ], 4, 'think-demo-with-bubble-actions'),
        _$cc(Bubble, {
            'avatar': true,
            'roleName': 'AI 助手',
            'streaming': this.get('streaming'),
            'typing': true,
            'loading': this.get('loading') && !this.get('thinkingContent'),
            'variant': 'plain',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['beforeContent'] = function($super) {
                            return (
                                (this.get('hasThinking')) ?
                                    _$cc(Think, {
                                        'title': this.get('thinkingTitle'),
                                        'content': this.get('thinkingContent'),
                                        'loading': this.get('thinking'),
                                        'blink': this.get('thinking'),
                                        'ev-$model:expanded': function($v) {
                                            $this.set('thinkExpanded', $v);
                                        },
                                        'expanded': $this.get('thinkExpanded')
                                    }) :
                                    undefined
                            );
                        }),
                        (__$blocks['beforeContent'] = function($super, data) {
                            var block = $blocks['beforeContent'];
                            var callBlock = function() {
                                return _$blocks['beforeContent'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['content'] = function($super) {
                            return (
                                _$cc(XMarkdown, {
                                    'content': this.get('answer'),
                                    'streaming': this.get('streaming'),
                                    'loading': false,
                                    'typing': {interval: 20, step: 3}
                                })
                            );
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'think-demo-with-bubble');
};